var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-margin-top u-margin-bottom u-display-flex u-width--100% u-justify-content-center u-align-items-center"},[_c('span',{staticClass:"loader primary-loading small-loader"})])
}]

export { render, staticRenderFns }